import api from '../../../../services/api';

type FinalizeTaskImagesRequest = {
  taskId: number;
  draftId: string;
};

export const finalizeTaskImages = async ({ taskId, draftId }: FinalizeTaskImagesRequest) => {
  await api.post('/umbraco/api/ImageStore/FinalizeTaskImages', { taskId, draftId });
};
